module.exports = __webpack_public_path__ + "img/save-print-box-es.e7a79a24.png";